import { api } from '@/fsd/shared/api';
import { ITariff } from '../../model/types/ITariff';

export const getTariffs = async (): Promise<ITariff[]> => {
  try {
    const data = await api.get<ITariff[]>('/api/v1/payment/tariffs/');

    return data;
  } catch (e) {
    console.error('Ошибка при получении тарифов:', e);
    return [];
  }
};
